import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import logo from './assets/images/logo.png';
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from '@material-ui/icons/Menu';
import {ListItem, ListItemIcon, SwipeableDrawer} from "@material-ui/core";
import ShowInMobile from "../responsive/ShowInMobile";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";

const useStyles = makeStyles(theme => ({
    AppBar: {
        borderRight: '1rem solid #4D5D89',
        borderLeft: '1rem solid #4D5D89',
        //marginBottom: theme.spacing(2),
    },
    logo: {
        marginRight: theme.spacing(2),
        marginLeft: -6,
        width: 125,
        [theme.breakpoints.down('xs')]: {
            width: 100,
            height: 'auto'
        }
    },
    grow: {
        flexGrow: 1,
    },
    separator: {
        width: 1,
        height: 28,
        backgroundColor: 'white',
        marginRight: theme.spacing(2)
    },
    title: {
        color: '#f4ce30',
        lineHeight: 1.2
    },
    subtitle: {
        color: '#CCC',
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    menuList: {
        width: 250
    }
}));

export default function Header(props) {
    const {
        title,
        subtitle,
        children,
        mobileMenu = false,
        mobileMenuOptions = []
    } = props;
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const toogleMenu = () => setOpen(prevState => !prevState);

    const handleClickMobileMenuItem = onClick => () => {
        !!onClick && onClick();

        toogleMenu();
    };

    return (
        <>
            <AppBar position='static' className={classes.AppBar}>
                <Toolbar>
                    {mobileMenu && (
                        <ShowInMobile>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={toogleMenu}
                                edge="start"
                                className={classes.menuButton}>
                                <MenuIcon />
                            </IconButton>
                        </ShowInMobile>
                    )}
                    <img src={logo} alt='Unaerp' className={classes.logo} />
                    <div className={classes.separator} />
                    <div className={classes.grow}>
                        <Typography variant='caption' className={classes.subtitle}>
                            {subtitle}
                        </Typography>
                        <Typography variant='h6' color='inherit' className={classes.title}>
                            {title}
                        </Typography>
                    </div>
                    {children}
                </Toolbar>
            </AppBar>
            {mobileMenu && (
                <ShowInMobile>
                    <SwipeableDrawer
                        anchor='left'
                        open={open}
                        onClose={toogleMenu}
                        onOpen={toogleMenu}>
                        <List className={classes.menuList}>
                            {mobileMenuOptions.map(({ label, onClick, icon : Icon }) => (
                                <Fragment key={label}>
                                    <ListItem
                                        button
                                        onClick={handleClickMobileMenuItem(onClick)}>
                                        <ListItemIcon>
                                            <Icon />
                                        </ListItemIcon>
                                        <ListItemText primary={label} />
                                    </ListItem>
                                    <Divider />
                                </Fragment>
                            ))}
                        </List>
                    </SwipeableDrawer>
                </ShowInMobile>
            )}
        </>
    );
};

Header.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    mobileMenu: PropTypes.bool,
    mobileMenuOptions: PropTypes.array
};